import * as userStorageService from '../services/user-storage-service';

const STORAGE_KEY = 'app_props';

export const fetchAppProps = () => {
    return userStorageService.get(STORAGE_KEY);
}

export const activateUserDetailed = (userId, type = 'flyout', tab = 'tasks') => {
    const props = userStorageService.get(STORAGE_KEY) || {};
    userStorageService.set(STORAGE_KEY, Object.assign({}, props, {
        activeUserDetailed: userId,
        userDetailedType: type,
        userDetailedTab: tab
    }));
}

export const deactivateUserDetailed = () => {
    const props = userStorageService.get(STORAGE_KEY) || {};
    userStorageService.set(STORAGE_KEY, Object.assign({}, props, {
        activeUserDetailed: null
    }));
}
